import React, { Component } from "react"
import Layout from "../Layout/Layout/Layout"
import SEO from "../SEO/SEO"
import Header from "../Shop/Header/Header"
import Shop from "../Shop/Shop/Shop"
import Utils from "../../utils/node.utils"

export default class ShopPage extends Component {
  componentDidMount() {
    this.setState({
      subCategories: Utils.ParseCategoryFilters(
        this.props.location.search,
        this.props.subCategories
      ),
    })
  }

  render() {
    const {
      title,
      language,
      mainCategories,
      subCategories,
      location,
      breadCrumbs,
      breadCrumb,
      originPage,
      description,
      contentMap,
      commonContentMap,
      products,
      keywords,
    } = this.props

    const tsValue = location.state ? location.state.ts_value : undefined

    return (
      <Layout
        origin={location.origin}
        originPage={originPage}
        language={language}
        commonContentMap={commonContentMap}
      >
        <SEO
          title={title}
          language={language}
          keywords={keywords}
          description={description}
          selfLink={originPage}
        />

        <Header breadCrumbs={breadCrumbs} commonContentMap={commonContentMap} />
        <Shop
          products={products}
          mainCategories={mainCategories}
          subCategories={subCategories}
          location={location}
          breadCrumb={breadCrumb}
          language={language}
          tsValue={tsValue}
          contentMap={contentMap}
          commonContentMap={commonContentMap}
          search={location.search}
        />
      </Layout>
    )
  }
}
